import React, { ReactElement } from 'react'

import styles from './LineDivider.module.less'

export default function LineDivider(): ReactElement {
  return <div className={styles.LineDivider} />
}
